const getWorkingDayStart = (date = new Date(), hours = 5, minutes = 0) => {

	return new Date(date.getFullYear(), date.getMonth(), date.getDate(), hours, minutes, 0, 0)
}

export default getWorkingDayStart
